/**
 * One grapheme segmenter per isolate, built on first use.
 *
 * Constructing an `Intl.Segmenter` loads ICU segmentation data. At module
 * scope that ran in the API worker's global scope on every cold start —
 * counted against Cloudflare's 1 s startup limit — for a feature only the
 * character counters use. Built lazily, the first count pays it instead.
 */
let segmenter: Intl.Segmenter | null = null;

export function graphemeSegmenter() {
  segmenter ??= new Intl.Segmenter();

  return segmenter;
}
